export default __webpack_public_path__ + "static/media/verify_phone.b14c96ec.png";